import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebarpaiment';

const API_BASE_URL = '    https://vmi1977988.contaboserver.net/api2';

const handleLogout = () => {
  localStorage.removeItem('token');
  window.location.href = '/';
};

const EtudiantsDesistement = () => {
  useEffect(() => {
    const userStr = localStorage.getItem('user');
    const loggedInUser = userStr ? JSON.parse(userStr) : null;
    if (loggedInUser?.email?.toLowerCase() === 'hiba@supemir.com') {
      window.location.href = '/manager/listePaiement';
    }
  }, []);

  const [etudiants, setEtudiants] = useState([]);
  const [etudiantsFiltres, setEtudiantsFiltres] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEtudiant, setSelectedEtudiant] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingMontant, setEditingMontant] = useState(null);
  const [nouveauMontant, setNouveauMontant] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: '', type: '' }), 5000);
  };

  useEffect(() => {
    fetchDesistements();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setEtudiantsFiltres(etudiants);
    } else {
      const filtered = etudiants.filter(e =>
        e.nomComplet?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.telephone?.includes(searchTerm) ||
        e.desistement?.raison?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setEtudiantsFiltres(filtered);
    }
  }, [searchTerm, etudiants]);

  const fetchDesistements = async () => {
    setLoading(true);
    try {
      const config = getAuthConfig();
      const { data } = await axios.get(`${API_BASE_URL}/admin/etudiants/desistements`, config);

      setEtudiants(data.etudiants);
      setEtudiantsFiltres(data.etudiants);
      setStats(data.stats);
    } catch (err) {
      console.error('Erreur chargement désistements:', err);
      showMessage('❌ Erreur lors du chargement des données', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateMontant = async (etudiantId) => {
    if (!nouveauMontant || parseFloat(nouveauMontant) < 0) {
      showMessage('❌ Montant invalide', 'error');
      return;
    }

    try {
      const config = getAuthConfig();
      await axios.patch(
        `${API_BASE_URL}/admin/etudiants/${etudiantId}/montant-recuperable`,
        { montantRecuperable: parseFloat(nouveauMontant) },
        config
      );

      showMessage('✅ Montant récupérable mis à jour avec succès', 'success');
      setEditingMontant(null);
      setNouveauMontant('');
      fetchDesistements();
    } catch (err) {
      console.error('Erreur mise à jour montant:', err);
      showMessage('❌ Erreur lors de la mise à jour', 'error');
    }
  };

  const handleVoirDetails = (etudiant) => {
    setSelectedEtudiant(etudiant);
    setShowModal(true);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('fr-FR');
  };

  const formatMontant = (montant) => {
    return new Intl.NumberFormat('fr-FR').format(montant || 0);
  };

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundImage: 'linear-gradient(135deg, #f0f9ff 0%, #a6dbff 25%, #f3e8ff 100%)',
      padding: '20px'
    },
    mainContent: {
      maxWidth: '1400px',
      margin: '0 auto'
    },
    header: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '30px',
      marginBottom: '25px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    subtitle: {
      color: '#6b7280',
      fontSize: '14px'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '25px'
    },
    statCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    statIcon: {
      width: '50px',
      height: '50px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    statContent: {
      flex: 1
    },
    statLabel: {
      fontSize: '13px',
      color: '#6b7280',
      marginBottom: '5px',
      fontWeight: '500'
    },
    statValue: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1f2937'
    },
    searchContainer: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '25px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    },
    searchInput: {
      width: '100%',
      padding: '12px 40px 12px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '14px',
      outline: 'none'
    },
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      overflowX: 'auto'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    th: {
      padding: '12px',
      textAlign: 'left',
      borderBottom: '2px solid #e5e7eb',
      fontSize: '13px',
      fontWeight: '600',
      color: '#374151',
      backgroundColor: '#f9fafb'
    },
    td: {
      padding: '12px',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '14px',
      color: '#1f2937'
    },
    badge: {
      display: 'inline-block',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '500'
    },
    badgeWarning: {
      backgroundColor: '#fef3c7',
      color: '#92400e'
    },
    badgeDanger: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    badgeSuccess: {
      backgroundColor: '#d1fae5',
      color: '#065f46'
    },
    button: {
      padding: '8px 12px',
      borderRadius: '6px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '500',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s ease'
    },
    buttonPrimary: {
      backgroundColor: '#3b82f6',
      color: 'white'
    },
    buttonSuccess: {
      backgroundColor: '#10b981',
      color: 'white'
    },
    buttonSecondary: {
      backgroundColor: '#e5e7eb',
      color: '#374151'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '30px',
      maxWidth: '800px',
      width: '100%',
      maxHeight: '90vh',
      overflowY: 'auto',
      boxShadow: '0 20px 50px rgba(0,0,0,0.3)'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      paddingBottom: '15px',
      borderBottom: '2px solid #e5e7eb'
    },
    modalTitle: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#1f2937'
    },
    infoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '15px',
      marginBottom: '20px'
    },
    infoItem: {
      padding: '12px',
      backgroundColor: '#f9fafb',
      borderRadius: '8px',
      border: '1px solid #e5e7eb'
    },
    infoLabel: {
      fontSize: '12px',
      color: '#6b7280',
      marginBottom: '4px',
      fontWeight: '500'
    },
    infoValue: {
      fontSize: '15px',
      color: '#1f2937',
      fontWeight: '600'
    },
    paiementsList: {
      marginTop: '20px'
    },
    paiementItem: {
      padding: '12px',
      backgroundColor: '#f0f9ff',
      borderRadius: '8px',
      marginBottom: '10px',
      border: '1px solid #bae6fd'
    },
    message: {
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: '500'
    },
    messageSuccess: {
      backgroundColor: '#f0fdf4',
      border: '1px solid #bbf7d0',
      color: '#15803d'
    },
    messageError: {
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      color: '#dc2626'
    },
    editMontantContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    editInput: {
      padding: '6px 10px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      width: '120px',
      fontSize: '14px'
    }
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <Sidebar onLogout={handleLogout} />
        <div style={styles.mainContent}>
          <div style={styles.header}>
            <div style={{ textAlign: 'center', padding: '40px' }}>
              Chargement des données...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <Sidebar onLogout={handleLogout} />

      <div style={styles.mainContent}>
        {message.text && (
          <div style={{
            ...styles.message,
            ...(message.type === 'error' ? styles.messageError : styles.messageSuccess)
          }}>
            {message.text}
          </div>
        )}

        <div style={styles.header}>
          <h1 style={{ ...styles.title, justifyContent: 'center' }}>
            Étudiants en Désistement
          </h1>
          <p style={{ ...styles.subtitle, textAlign: 'center' }}>
            Gestion des étudiants ayant abandonné leur formation
          </p>
        </div>

        {stats && (
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statContent}>
                <div style={styles.statLabel}>Total Désistements</div>
                <div style={styles.statValue}>{stats.total}</div>
              </div>
            </div>

            <div style={styles.statCard}>
              <div style={styles.statContent}>
                <div style={styles.statLabel}>Prix Total Cumulé</div>
                <div style={styles.statValue}>{formatMontant(stats.totalPrixGlobal)} MAD</div>
              </div>
            </div>

            <div style={styles.statCard}>
              <div style={styles.statContent}>
                <div style={styles.statLabel}>Total Payé</div>
                <div style={styles.statValue}>{formatMontant(stats.totalPayeGlobal)} MAD</div>
              </div>
            </div>

            <div style={styles.statCard}>
              <div style={styles.statContent}>
                <div style={styles.statLabel}>Montant Récupérable</div>
                <div style={styles.statValue}>{formatMontant(stats.montantRecuperableTotal)} MAD</div>
              </div>
            </div>
          </div>
        )}

        <div style={styles.searchContainer}>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Rechercher par nom, email, téléphone ou raison..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
            />
          </div>
        </div>

        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Étudiant</th>
                <th style={styles.th}>Contact</th>
                <th style={styles.th}>Formation</th>
                <th style={styles.th}>Prix Total</th>
                <th style={styles.th}>Payé</th>
                <th style={styles.th}>Reste</th>
                <th style={styles.th}>Récupérable</th>
                <th style={styles.th}>Date Désistement</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {etudiantsFiltres.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ ...styles.td, textAlign: 'center', padding: '40px' }}>
                    <div>Aucun étudiant en désistement trouvé</div>
                  </td>
                </tr>
              ) : (
                etudiantsFiltres.map((etudiant) => (
                  <tr key={etudiant._id}>
                    <td style={styles.td}>
                      <div style={{ fontWeight: '600' }}>{etudiant.nomComplet}</div>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>
                        {etudiant.anneeScolaire}
                      </div>
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontSize: '13px' }}>{etudiant.email}</div>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>{etudiant.telephone}</div>
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontSize: '13px' }}>{etudiant.typeFormation || '-'}</div>
                      {etudiant.cours && etudiant.cours.length > 0 && (
                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                          {etudiant.cours.join(', ')}
                        </div>
                      )}
                    </td>
                    <td style={styles.td}>
                      <span style={{ fontWeight: '600' }}>
                        {formatMontant(etudiant.paiementInfo?.prixTotal)} MAD
                      </span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: '#059669', fontWeight: '600' }}>
                        {formatMontant(etudiant.paiementInfo?.totalPaye)} MAD
                      </span>
                    </td>
                    <td style={styles.td}>
                      <span style={{
                        color: etudiant.paiementInfo?.resteAPayer > 0 ? '#dc2626' : '#6b7280',
                        fontWeight: '600'
                      }}>
                        {formatMontant(etudiant.paiementInfo?.resteAPayer)} MAD
                      </span>
                    </td>
                    <td style={styles.td}>
                      {editingMontant === etudiant._id ? (
                        <div style={styles.editMontantContainer}>
                          <input
                            type="number"
                            value={nouveauMontant}
                            onChange={(e) => setNouveauMontant(e.target.value)}
                            placeholder="0"
                            min="0"
                            style={styles.editInput}
                          />
                          <button
                            onClick={() => handleUpdateMontant(etudiant._id)}
                            style={{ ...styles.button, ...styles.buttonSuccess }}
                            title="Sauvegarder"
                          >
                            Sauvegarder
                          </button>
                          <button
                            onClick={() => {
                              setEditingMontant(null);
                              setNouveauMontant('');
                            }}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                            title="Annuler"
                          >
                            Annuler
                          </button>
                        </div>
                      ) : (
                        <div style={styles.editMontantContainer}>
                          <span style={{ fontWeight: '600', color: '#d97706' }}>
                            {formatMontant(etudiant.desistement?.montantRecuperable || 0)} MAD
                          </span>
                          <button
                            onClick={() => {
                              setEditingMontant(etudiant._id);
                              setNouveauMontant(etudiant.desistement?.montantRecuperable || 0);
                            }}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                            title="Modifier"
                          >
                            Modifier
                          </button>
                        </div>
                      )}
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontSize: '13px' }}>
                        {formatDate(etudiant.desistement?.dateDesistement)}
                      </div>
                      {etudiant.desistement?.raison && (
                        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>
                          {etudiant.desistement.raison.substring(0, 30)}
                          {etudiant.desistement.raison.length > 30 ? '...' : ''}
                        </div>
                      )}
                    </td>
                    <td style={styles.td}>
                      <button
                        onClick={() => handleVoirDetails(etudiant)}
                        style={{ ...styles.button, ...styles.buttonPrimary }}
                      >
                        Détails
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Détails */}
      {showModal && selectedEtudiant && (
        <div style={styles.modal} onClick={() => setShowModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>Détails de l'étudiant</h2>
              <button
                onClick={() => setShowModal(false)}
                style={{ ...styles.button, ...styles.buttonSecondary }}
              >
                Fermer
              </button>
            </div>

            <div style={styles.infoGrid}>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Nom Complet</div>
                <div style={styles.infoValue}>{selectedEtudiant.nomComplet}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Email</div>
                <div style={styles.infoValue}>{selectedEtudiant.email}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Téléphone</div>
                <div style={styles.infoValue}>{selectedEtudiant.telephone || '-'}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>CIN</div>
                <div style={styles.infoValue}>{selectedEtudiant.cin || '-'}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Formation</div>
                <div style={styles.infoValue}>{selectedEtudiant.typeFormation || '-'}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Année Scolaire</div>
                <div style={styles.infoValue}>{selectedEtudiant.anneeScolaire}</div>
              </div>
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>Mode de Paiement</div>
                <div style={styles.infoValue}>
                  {selectedEtudiant.modePaiement ?
                    selectedEtudiant.modePaiement.charAt(0).toUpperCase() + selectedEtudiant.modePaiement.slice(1)
                    : '-'}
                </div>
              </div>
            </div>

            {/* Section Financière */}
            <div style={{
              marginTop: '20px',
              padding: '20px',
              backgroundColor: '#f0f9ff',
              borderRadius: '8px',
              border: '2px solid #bae6fd'
            }}>
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', color: '#0369a1' }}>
                Informations Financières
              </h3>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Prix Total</div>
                  <div style={{ ...styles.infoValue, color: '#0369a1' }}>
                    {formatMontant(selectedEtudiant.paiementInfo?.prixTotal)} MAD
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Frais d'Inscription Payés</div>
                  <div style={{ ...styles.infoValue, color: '#8b5cf6' }}>
                    {formatMontant(selectedEtudiant.paiementInfo?.totalInscription)} MAD
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Formation Payée</div>
                  <div style={{ ...styles.infoValue, color: '#059669' }}>
                    {formatMontant(selectedEtudiant.paiementInfo?.totalFormation)} MAD
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Total Payé</div>
                  <div style={{ ...styles.infoValue, color: '#059669', fontSize: '18px' }}>
                    {formatMontant(selectedEtudiant.paiementInfo?.totalPaye)} MAD
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Reste à Payer</div>
                  <div style={{ ...styles.infoValue, color: '#dc2626', fontSize: '18px' }}>
                    {formatMontant(selectedEtudiant.paiementInfo?.resteAPayer)} MAD
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Montant Récupérable</div>
                  <div style={{ ...styles.infoValue, color: '#d97706', fontSize: '18px' }}>
                    {formatMontant(selectedEtudiant.desistement?.montantRecuperable || 0)} MAD
                  </div>
                </div>
              </div>
            </div>

            {/* Section Désistement */}
            <div style={{
              marginTop: '20px',
              padding: '20px',
              backgroundColor: '#fef2f2',
              borderRadius: '8px',
              border: '2px solid #fecaca'
            }}>
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', color: '#dc2626' }}>
                Informations Désistement
              </h3>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Date de Désistement</div>
                  <div style={styles.infoValue}>
                    {formatDate(selectedEtudiant.desistement?.dateDesistement)}
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <div style={styles.infoLabel}>Date de Désactivation</div>
                  <div style={styles.infoValue}>
                    {formatDate(selectedEtudiant.dateDesactivation)}
                  </div>
                </div>
              </div>
              {selectedEtudiant.desistement?.raison && (
                <div style={{ marginTop: '15px' }}>
                  <div style={styles.infoLabel}>Raison du Désistement</div>
                  <div style={{
                    padding: '12px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#374151'
                  }}>
                    {selectedEtudiant.desistement.raison}
                  </div>
                </div>
              )}
              {selectedEtudiant.desistement?.commentaire && (
                <div style={{ marginTop: '15px' }}>
                  <div style={styles.infoLabel}>Commentaire</div>
                  <div style={{
                    padding: '12px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#374151'
                  }}>
                    {selectedEtudiant.desistement.commentaire}
                  </div>
                </div>
              )}
            </div>

            {/* Section Commercial/Partner */}
            {(selectedEtudiant.commercial || selectedEtudiant.partner) && (
              <div style={{
                marginTop: '20px',
                padding: '20px',
                backgroundColor: '#f3e8ff',
                borderRadius: '8px',
                border: '2px solid #d8b4fe'
              }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', color: '#7c3aed' }}>
                  Informations Commerciales
                </h3>
                <div style={styles.infoGrid}>
                  {selectedEtudiant.commercial && (
                    <div style={styles.infoItem}>
                      <div style={styles.infoLabel}>Commercial</div>
                      <div style={styles.infoValue}>
                        {selectedEtudiant.commercial.nom || '-'}
                      </div>
                      {selectedEtudiant.commercial.email && (
                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                          {selectedEtudiant.commercial.email}
                        </div>
                      )}
                    </div>
                  )}
                  {selectedEtudiant.partner && (
                    <div style={styles.infoItem}>
                      <div style={styles.infoLabel}>Partner</div>
                      <div style={styles.infoValue}>
                        {selectedEtudiant.partner.nomPartner || '-'}
                      </div>
                      <div style={{ fontSize: '12px', marginTop: '4px' }}>
                        <span style={{
                          ...styles.badge,
                          ...(selectedEtudiant.partner.active ? styles.badgeSuccess : styles.badgeDanger)
                        }}>
                          {selectedEtudiant.partner.active ? 'Actif' : 'Inactif'}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Section Paiements */}
            {selectedEtudiant.paiementInfo?.paiements?.length > 0 && (
              <div style={styles.paiementsList}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  marginBottom: '15px'
                }}>
                  Historique des Paiements ({selectedEtudiant.paiementInfo.nombrePaiements})
                </h3>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {selectedEtudiant.paiementInfo.paiements.map((paiement, index) => (
                    <div key={paiement._id} style={styles.paiementItem}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '8px'
                      }}>
                        <div>
                          <span style={{ fontWeight: '600', fontSize: '15px' }}>
                            {formatMontant(paiement.montant)} MAD
                          </span>
                          <span style={{
                            ...styles.badge,
                            ...(paiement.typePaiement === 'inscription' ?
                              { backgroundColor: '#e0e7ff', color: '#3730a3' } :
                              { backgroundColor: '#d1fae5', color: '#065f46' }),
                            marginLeft: '10px'
                          }}>
                            {paiement.typePaiement === 'inscription' ? 'Inscription' : 'Formation'}
                          </span>
                        </div>
                        <div style={{ textAlign: 'right', fontSize: '13px', color: '#6b7280' }}>
                          <div>{formatDate(paiement.datePaiement || paiement.createdAt)}</div>
                          {paiement.numeroSerie && (
                            <div style={{ fontSize: '11px', marginTop: '2px' }}>
                              N° {paiement.numeroSerie}
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ fontSize: '13px', color: '#374151' }}>
                        {paiement.modePayment && (
                          <div style={{ marginBottom: '4px' }}>
                            <strong>Mode:</strong> {paiement.modePayment}
                          </div>
                        )}
                        {paiement.note && (
                          <div style={{ color: '#6b7280', fontSize: '12px', marginTop: '6px' }}>
                            📝 {paiement.note}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{
              marginTop: '25px',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowModal(false)}
                style={{ ...styles.button, ...styles.buttonPrimary, padding: '12px 24px' }}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EtudiantsDesistement;